
import { CascaderPanel } from "element-ui"
import _ from "lodash"
import { getLang } from "@/plugins/env"

export default {
  name: "Cascader",
  // serverCacheKey: _ => {
  //   return `${getLang()}_Cascader`
  // },
  components: {
    [CascaderPanel.name]: CascaderPanel
  },
  directives: {
    "click-outside": {
      inserted: function (el, binding, vnode) {
        const categoryEl = document.getElementById("all-categories")
        el.event = function (event) {
          if (
            !(el === event.target || el.contains(event.target)) &&
            !(categoryEl && categoryEl.contains(event.target))
          ) {
            if (typeof vnode.context[binding.expression] === "function") {
              vnode.context[binding.expression](event)
            }
          }
        }
        document.body.addEventListener("click", el.event, true)
      },
      unbind: function (el) {
        document.body.removeEventListener("click", el.event, true)
      }
    }
  },
  data() {
    return {
      cascaderData: [],
      levelStack: [],
      activeStack: [],
      isLeava: true, // 是否离开容器,
      categoryLink: ""
    }
  },
  created() {
    if (this.$store.state.cascaderData) {
      this.cascaderData = this.$store.state.cascaderData
    }
  },
  mounted() {},
  methods: {
    getCategoryLink(node, { id }) {
      const ids = [id]
      let parentNode = node.parent
      while (parentNode && parentNode.value) {
        ids.unshift(parentNode.value)
        parentNode = parentNode.parent
      }
      return `${this.MAIN_PATH}/category/${ids.join("-")}/1.html`
    },
    onHide() {
      this.$emit("hide")
    }
  }
}
